export enum ExchangeRateTab {
  ACTIVE = 1,
  HISTORY = 2,
}